import React from "react";
import {
  SaveButton,
  Toolbar,
  required,
  DeleteButton,
  Edit,
  SimpleForm,
  TextField,
  TextInput
} from "react-admin";

const TeamEdit = (props) => {
  const CustomToolbar = function(props) {
    const redirectPath = `/schools/${props.record.school.id}/show/1`;
    return (
      <Toolbar {...props}>
        <SaveButton redirect={redirectPath} />
        <DeleteButton undoable={false} redirect={redirectPath} />
      </Toolbar>
    );
  };

  return (
    <Edit undoable={false} {...props}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextField source="id" />
        <TextField source="sportCode" />
        <TextInput source="name" validate={[required()]} />
        <TextInput source="teamCode" />
      </SimpleForm>
    </Edit>
  );
};

export default TeamEdit;
